/**
 * Dynamic importers for the `ui` namespace (shared package strings).
 * Consumed by host apps via createI18n({ registrations: { ui: uiI18nLoaders } }).
 */
export const uiI18nLoaders = {
  en: () => import('../../locales/en.json'),
  es: () => import('../../locales/es.json'),
};
